// src/components/DisclaimerStep.js

import React from 'react';
import { motion } from 'framer-motion';

const LeftArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M9.707 4.293a1 1 0 00-1.414 1.414L11.586 8H4a1 1 0 100 2h7.586l-3.293 3.293a1 1 0 001.414 1.414l5-5a1 1 0 000-1.414l-5-5z" clipRule="evenodd" />
  </svg>
);

const RightArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L13.586 11H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd"/>
  </svg>
);

export default function DisclaimerStep({ onNext, onBack }) {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Aviso de Multa por Cancelamento</h2>
        <div className="bg-gray-50 rounded-xl p-6 sm:p-8">
          <p className="text-gray-700 text-lg leading-relaxed">
            Ao continuar, você declara estar ciente de que não comparecer sem 
            aviso prévio de <strong className="text-[#e91e63]">2 horas</strong> pode configurar má-fé contratual, prevista no Código Civil, 
            estando sujeito a multa de <strong className="text-[#e91e63]">R$ 50,00</strong>.
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onNext({ accepted: true, timestamp: new Date().toISOString() })}
          className="bg-[#e91e63] text-white rounded-xl py-4 px-8 flex items-center justify-center text-lg font-medium hover:bg-[#d81557] transition-colors"
        >
          Entendi, estou ciente <RightArrow />
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onBack}
          className="text-gray-600 hover:text-gray-800 flex items-center justify-center"
        >
          <LeftArrow /> Voltar
        </motion.button>
      </div>
    </div>
  );
}
